import { render } from "./fontsSteinberg.vue?vue&type=template&id=654f6bca"
const script = {}

import "./fontsSteinberg.vue?vue&type=style&index=0&id=654f6bca&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__